import { render, staticRenderFns } from "./DataViewAssignee.vue?vue&type=template&id=0fe16d26&"
import script from "./DataViewAssignee.vue?vue&type=script&lang=js&"
export * from "./DataViewAssignee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports